
/**
 * ldb store types
 */

const mutationTypes = {
  LDB_GET_HISTORY_SEARCH_LDBS: 'getHistorySearchLdbs',
  LDB_SET_HISTORY_SEARCH_LDB: 'setHistorySearchLdb'
}
const actionTypes = {
  LDB_GET_HISTORY_SEARCH_LDBS: 'getHistorySearchLdbs',
  LDB_SET_HISTORY_SEARCH_LDB: 'setHistorySearchLdb'
}

module.exports = {
  mutationTypes,
  actionTypes
}



// WEBPACK FOOTER //
// ./src/store/types/ldb.js